const BASE_CONFIG = {
  'project': {
    'balanceIndexPage': 2
  },
  'type': 'object',
  'paths': [
    {
      "path": "/resource/ibalance",
      "abType": "abSyncLayerId"
    }
  ]
};

// 页面同步实验cookie解码配置, 不同环境layerId不一样
const layerIds = {
  local: {
    abSyncLayerId: 238162
  },
  dev: {
    abSyncLayerId: 238162
  },
  test: {
    abSyncLayerId: 238162
  },
  staging: {
    abSyncLayerId: 23835
  },
  prod: {
    abSyncLayerId: 23960
  }
};

const getEnv = () => {
  const host = window?.location?.host;
  if (/\.dev\.sankuai\.com/.test(host)) {
    return 'dev';
  } else if (/\.test\.sankuai\.com/.test(host)) {
    return 'test';
  } else if (/\.st\.(sankuai|meituan)\.com/.test(host)) {
    return 'staging';
  } else if (/\.meituan\.com/.test(host)) {
    return 'prod';
  } else {
    return 'local';
  }
};

export const getCookieConfig = () => {
  const env = getEnv();
  const layerIdObj = layerIds[env || 'prod'];

  return {
    ...BASE_CONFIG,
    paths: BASE_CONFIG.paths.map(path => ({ ...path, layerId: layerIdObj?.[path.abType] }))
  };
};